/*
* Copyright (C) Regione Lombardia
*/
import { Sorting, SortingDirectionEnum } from './sorting';

export class Paginator {

    page: number;
    size: number;
    total: number;
    orders: Array<Sorting>;
    totalPages: number;

    constructor() {
        this.resetPaginator();
    }

    public getQueryPaginator(orders: Sorting[]) {
        const order = orders.filter(order =>
            order.direction !== SortingDirectionEnum.EMPTY
        ).map(order =>
            'sort=' + order.field + ',' + order.direction
        ).join('&');
        return 'page=' + (this.page - 1)
            + '&size=' + this.size
            + (order ? '&' + order : '');
    }

    public getQueryPaginatorExport(orders: Sorting[]) {
        const order = orders.filter(order =>
            order.direction !== SortingDirectionEnum.EMPTY
        ).map(order =>
            'sort=' + order.field + ',' + order.direction
        ).join('&');
        return 'page=0&size=9999' + (order ? '&' + order : '');}

    public resetPaginator() {
        this.page = 1;
        this.size = 10;
        this.total = 0;
        this.orders = [];
        this.totalPages = 0;
    }

    public setTotalPage(totalCount: number) {
        this.total = totalCount;
        this.totalPages = Math.ceil(totalCount / this.size);
    }

}
